.emptyBlock {
  color: var(--tuna-palette-text-secondary);
  display: flex;
  align-items: center;
  cursor: pointer;
}
